import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'accent' | 'danger' | 'outline';
  className?: string;
}
const tones: Record<string, string> = {
  accent: 'border-accent/40 bg-accent/10 text-accent',
  danger: 'border-danger/40 bg-danger/10 text-danger',
  outline: 'border-line bg-panel text-muted'
};
export function Pill({
  children,
  tone = 'accent',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center justify-center whitespace-nowrap rounded-full border px-3.5 py-1 text-center font-display text-xs font-semibold uppercase leading-none tracking-[0.16em] ${tones[tone]} ${className}`} data-id="element-161" data-mp="1aw3hmfz3cxoh">
      {children}
    </span>;
}